"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordTypeResource = void 0;
var RecordTypeResource = /** @class */ (function () {
    function RecordTypeResource(headings) {
        var _this = this;
        this.getHeading = function (layerType, layerSubType) {
            var heading = "";
            var rec;
            for (var i = 0; i < _this.headings.length; i++) {
                rec = _this.headings[i];
                if (rec.recordTypeCode === layerType) {
                    if (rec.recordSubTypeCode === null) {
                        heading = rec.heading;
                        if (layerSubType === null) {
                            break;
                        }
                    }
                    else if (rec.recordSubTypeCode === layerSubType) {
                        heading = rec.heading;
                        break;
                    }
                }
            }
            return heading;
        };
        this.headings = headings;
    }
    return RecordTypeResource;
}());
exports.RecordTypeResource = RecordTypeResource;
//# sourceMappingURL=RecordTypeResource.js.map